import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {
    BrowserRouter as Router,
    Switch,
    Route,
} from "react-router-dom";
import Home from './components/Home/Home';
import PageNotFound from './components/PageNotFound/PageNotFound';
import LeagueInfo from './components/LeagueInfo/LeagueInfo';

// 10-March-2021

const App = () => {

    return (
        <div >
            <Router>
                <Switch>
                    <Route path="/home">
                        <Home />
                    </Route>

                    <Route path="/leagueInfo/:league_id">
                        <LeagueInfo />
                    </Route>

                    <Route exact path="/">
                        <Home />
                    </Route>

                    <Route path="/*">
                        <PageNotFound />
                    </Route>
                </Switch>
            </Router>
        </div>
    );
};

export default App;